import Vue from 'vue'
import Vuex from 'vuex'
import auth, { authInit } from './auth'
import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    app
  }
})

authInit(store)

export default store